/**
 * Check if an offering accepts retirement funds only
 * @param {Object} offeringData - The offering data object
 * @returns {boolean} True if the offering accepts retirement funds only
 */
const isRetirementFundsOnly = (offeringData) => {
  if (!offeringData) return false;
  return offeringData.investmentSourceOfFunds === 'RETIREMENT_FUNDS_ONLY';
};

export const getCTAText = (offeringData) => {
  const campaignPageButtonDefaultCTAText = 'Invest Now';

  // Safety check: ensure isRetirementFundsOnly is a function and offeringData exists
  if (
    typeof isRetirementFundsOnly === 'function' &&
    offeringData &&
    isRetirementFundsOnly(offeringData)
  ) {
    return 'Invest with IRA';
  }

  if (offeringData?.offeringType === 'equity') {
    return 'Get Equity';
  }

  return campaignPageButtonDefaultCTAText;
};
